<!-- 我的动态 -->
<template>
  <div class="bar_blog">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">账户安全</div>
      </el-col>
    </el-row>
    <el-row class="account-area">
      <div class="account-area-title">【我的账户】</div>
      <p>
        <span class="account-area-l">账号：</span><span class="account-area-r">{{getUserSaveInforAjax.guideNumber}}</span>
      </p>
      <p>
        <span class="account-area-l">昵称：</span><span class="account-area-r">{{getUserSaveInforAjax.realName}}</span>
      </p>
      <p>
        <span class="account-area-l">密码修改：</span>
        <span class="account-area-r colorblue" @click="modifyInfor('password')">修改密码</span>
      </p>
      <p>
        <span class="account-area-l">手机绑定：</span>
        <span class="account-area-r colorblue" @click="modifyInfor('phone')">
            <template v-if="getUserSaveInforAjax.guideNumber == '' || !getUserSaveInforAjax.guideNumber">绑定手机
</template>

<template v-if="getUserSaveInforAjax.guideNumber != '' && getUserSaveInforAjax.guideNumber">
  更改手机
</template>
        </span>
      </p>
      <p>
        <span class="account-area-l">邮箱绑定：</span>
        <span class="account-area-r colorblue" @click="modifyInfor('email')">
<template v-if="getUserSaveInforAjax.checkStatus == 0">
  绑定邮箱
</template>

<template v-if="getUserSaveInforAjax.checkStatus == 1">
  更改邮箱
</template>
        </span>
      </p>
      <div class="account-area-title">【认证信息】</div>
      <p>
        <span class="account-area-l">身份证：</span>
        <span class="account-area-r colorblue" @click="modifyInfor('personcard')">
<template v-if="!getUserSaveInforAjax.proofImgPath && getUserSaveInforAjax.proofImgPath == '' || getUserSaveInforAjax.userImgPath == null">
  未上传
</template>

<template v-if="getUserSaveInforAjax.proofImgPath && getUserSaveInforAjax.proofImgPath != ''">
  已上传
</template>
        </span>
      </p>
      <p>
        <span class="account-area-l">导游证：</span>
        <span class="account-area-r colorblue" @click="modifyInfor('guide')">
<template v-if="!getUserSaveInforAjax.guideImgPath && getUserSaveInforAjax.guideImgPath == '' || getUserSaveInforAjax.userImgPath == null">
  未上传
</template>

<template v-if="getUserSaveInforAjax.guideImgPath && getUserSaveInforAjax.guideImgPath != ''">
  已上传
</template>
        </span>
      </p>
      <p>
        <span class="account-area-l">宣传照片：</span>
        <span class="account-area-r colorblue" @click="modifyInfor('auth')">        
<template v-if="!getUserSaveInforAjax.userImgPath && getUserSaveInforAjax.userImgPath == '' || getUserSaveInforAjax.userImgPath == null">
  未上传
</template>

<template v-if="getUserSaveInforAjax.userImgPath && getUserSaveInforAjax.userImgPath != ''">
  已上传
</template>
        </span>
      </p>
      <p>
        <span class="account-area-l">其他证件：</span>
        <span class="account-area-r colorblue" @click="modifyInfor('other')"> 
<template v-if="!getUserSaveInforAjax.otherImgPath && getUserSaveInforAjax.otherImgPath == '' || getUserSaveInforAjax.userImgPath == null">
  未上传
</template>

<template v-if="getUserSaveInforAjax.otherImgPath && getUserSaveInforAjax.otherImgPath != ''">
  已上传
</template>
        </span>
      </p>
      <div class="account-area-title">【账户绑定】</div>
      <p>
        <span class="account-area-l" >微信：</span>
        <span class="account-area-r" v-if="getUserSaveInforAjax.openid == '' || getUserSaveInforAjax.openid == null">未绑定（登录APP、小程序绑定）</span>
       <span class="account-area-r" v-if="getUserSaveInforAjax.openid != ''  && getUserSaveInforAjax.openid != null">已绑定</span>
      </p>
    </el-row>
  </div>
</template>

<!--JS-->
<script>
  import {
    selectUserDetailByProof
  } from "api/apis";
  import $ from "jquery";
  export default {
    data() {
      return {
        user_code: localStorage.getItem('pbw_user_pc_uid'),
        getUserSaveInforAjax: {},
      }
    },
    methods: {
      getUserSaveInfor() {
        selectUserDetailByProof({
          userCode: this.user_code
        }).then((res) => {
          if (res.code == '000000') {
            this.getUserSaveInforAjax = res.data
            console.log(this.getUserSaveInforAjax, "获取安全信息")
          } else {
            this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
          }
        })
      },
      modifyInfor(tab) {
        console.log(tab, "kkkk")
        // this.$router.push({
        //   name: 'modifyInfor',
        //   query: {
        //     type: tab
        //   }
        // })
          this.$router.push({
          name: 'authenticate',
          query: {
            type: tab
          }
        })
        
      }
    },
    created() {
      this.$nextTick(() => {
        this.getUserSaveInfor()
      })
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';
  @import '../../scss/demo.scss';
  /* 基本资料 */
  .avatar {
    height: 120px;
    border-radius: 90px;
    border: 1px solid #d6d6d6;
  }
  .bar_blog .dashed {
    border-bottom: 1px dashed #F1F1F1;
    padding-bottom: 20px;
    margin-bottom: 25px;
  }
  .bar_blog .title1 {
    font-size: 18px;
    color: #333;
  }
  .bar_blog .title1::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 27px;
    border-radius: 5px;
    vertical-align: bottom;
    background-color: #F16202;
    margin-right: 20px;
  }
  .bar_blog .title2,
  .bar_blog .title2 em {
    text-align: right;
    font-size: 14px;
    color: #959595;
    line-height: 27px;
  }
  .bar_blog .repeatable {
    padding-bottom: 20px;
  }
  .bar_blog .repeatable .name {
    font-size: 14px;
    text-align: right;
    line-height: 40px;
  }
  .bar_blog .repeatable .in input {
    color: #F16202
  }
  .el-border {
    border-radius: 50%;
    width: 100px;
    height: 100px;
    line-height: 100px;
    border: 1px solid #ddd;
    text-align: center;
  }
  .bar_blog .repeatable .sex {
    line-height: 40px;
    padding-left: 10px;
  }
  .name_money {
    padding: 20px 80px;
    border: 1px solid #d5d5d5;
    span {
      color: #f60;
    }
  }
  .personal-money-tip {
    font-size: 24px;
  }
  .personal-money {
    font-size: 56px;
    font-weight: bold;
  }
  .personal-money-btn {
    color: #fff !important;
    background: #698adb;
    padding: 16px 50px;
    border-radius: 10px;
    font-size: 18px;
  }
  .personal-money-btm-tip {
    color: #999 !important;
    float: right;
    margin-top: -20px;
    margin-right: 30px;
  }
  .personal-money-one {
    color: #fff !important;
    background: #698adb;
    padding: 6px 30px;
    border-radius: 10px;
    font-size: 16px;
    margin-top: 24px;
  }
  .personal-money-two {
    color: #fff !important;
    background: #26b3f4;
    padding: 6px 30px;
    border-radius: 10px;
    font-size: 16px;
    margin-top: 24px;
    margin-right: 20px;
  }
  /*账户安全*/
  .account-area {
    padding: 0px 78px;
    .account-area-title {
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
    }
    p {
      margin-bottom: 20px;
      span {
        display: inline-block;
        font-size: 14px;
      }
      .colorblue {
        color: #2e8bff;
        cursor: pointer;
      }
    }
    .account-area-l {
      width: 152px;
      color: #999;
      text-align: right;
    }
    .account-area-r {
      color: #666;
      text-align: left;
      padding-left: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/accountsecurity.vue